// BoutiqueClub reste disponible pour le développement local mais n'est publié
// que lorsqu'un build production l'active explicitement.
export const BOUTIQUECLUB_ENABLED = process.env.NODE_ENV !== "production"
  || process.env.REACT_APP_BOUTIQUECLUB_ENABLED === "true";
